module.exports = __webpack_public_path__ + "img/up.c2d65e64.svg";